import router from "@/router/index";
import APP_ERROR_CODES from "@/assets/data/errorCodes.js";

export default () => {
  function handleServerErrors(error) {
    const { code, message, status, statusText } = error.response.data;

    const errorCode = status || code;
    const errorMsg = statusText || message;

    router.push({
      name: "error",
      query: { status: errorCode, text: errorMsg },
    });
  }

  function handleMappedErrorResponses(code, errors) {
    const { field, error, callback } = APP_ERROR_CODES.get(code);
    if (callback) {
      callback();
    }

    return { field, error };
  }

  function handleErrorInSpaFlow(code, message) {
    router.push({
      name: "error",
      query: { status: code, text: message },
    });
  }

  return {
    handleServerErrors,
    handleMappedErrorResponses,
    handleErrorInSpaFlow,
  };
};
